// extracted by mini-css-extract-plugin
module.exports = {"container":"_CustomBox_container__r4Rpu","border":"_CustomBox_border__KGpG0","content":"_CustomBox_content__xv_D2","title":"_CustomBox_title__X4ne0"};